/* PUSHAS v30 small fixes (loaded on every page, deferred). */
(function(){
  /* Product page: the "Materials age. Items older than 5 years..." note only applies to older pairs.
     Hide it when the release date is within the last 5 years. No date found = leave it showing. */
  function materials(){
    var box=document.querySelector('.productView-details');if(!box)return;
    var m=(box.innerText||'').match(/Release Date:?\s*\n?\s*([A-Z][a-z]+ \d{1,2}, \d{4})/i);if(!m)return;
    var rel=new Date(m[1]);if(isNaN(rel))return;
    var cut=new Date();cut.setFullYear(cut.getFullYear()-5);
    if(rel<cut)return;
    box.querySelectorAll('p,div,span').forEach(function(el){
      if(el.children.length===0&&/^\s*Materials age\./.test(el.textContent)){
        var w=el.closest('.product__text.des')||el;w.style.display='none';
      }
    });
  }

  /* Pages that end on a black section (email sign-up, banner) showed an 80px white strip before the black footer:
     <main> has 80px bottom padding. Remove it when the last section is dark, and add a hairline so the two black blocks read as separate. */
  function footerGap(){
    var main=document.querySelector('main#MainContent');if(!main)return;
    var secs=[].filter.call(main.children,function(s){return s.offsetHeight>0});var last=secs[secs.length-1];if(!last)return;
    var dark=false,all=[last].concat([].slice.call(last.querySelectorAll('*')));
    for(var i=0;i<all.length&&i<400;i++){var el=all[i];if(el.offsetHeight<last.offsetHeight*0.8)continue;
      var m=getComputedStyle(el).backgroundColor.match(/[\d.]+/g);
      if(m&&(m.length<4||+m[3]>0)){dark=(+m[0]+ +m[1]+ +m[2])<90;break}}
    if(dark){main.style.setProperty('padding-bottom','0px','important');var f=document.querySelector('.wrapper-footer');if(f)f.style.borderTop='1px solid rgba(255,255,255,.08)'}
  }
  /* Product page sticky Add to Cart bar: pushas-2026.js hides it when the footer comes into view but never brings it back,
     so after reaching the bottom and scrolling up it stayed hidden until you scrolled past the main Add to Cart again.
     Show it whenever the main Add to Cart is above the screen and the footer is not on screen. */
  function stickyFix(){
    var bar=document.querySelector('.p26-sticky'),btn=document.querySelector('.productView-buttons'),ft=document.querySelector('.wrapper-footer');
    if(!bar||!btn||!ft||!('IntersectionObserver' in window))return !!document.querySelector('.p26-sticky');
    if(bar.__p26fix)return true;bar.__p26fix=1;
    var passed=false,foot=false;function set(){bar.classList.toggle('is-on',passed&&!foot)}
    new IntersectionObserver(function(es){es.forEach(function(e){passed=!e.isIntersecting&&e.boundingClientRect.top<0});set()},{threshold:0}).observe(btn);
    new IntersectionObserver(function(es){es.forEach(function(e){foot=e.isIntersecting});set()},{threshold:.05}).observe(ft);
    return true;
  }
  function sticky(){if(!document.body.classList.contains('template-product'))return;var n=0,t=setInterval(function(){if(stickyFix()||++n>30)clearInterval(t)},200)}
  function run(){materials();footerGap()}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',function(){run();sticky()});else{run();sticky()}
  window.addEventListener('load',function(){run();setTimeout(run,1200)});
})();
